import React, { useState } from "react";
import ProductCard from "./Productcard";
import AnalyticsService from "services/analytics.service";
import { EVENT_NAME } from "utils/constants";

const CommonProductCard = ({
  commonProduct,
  cart,
  clearFromCart,
  setCart,
  isRepairPage = false,
}) => {

  const [selectedProductId, setSelectedProductId] = useState(commonProduct.selectedProductId);

  const handleProductChange = (productId) => {
    const product = commonProduct.products.find(product => product.id === productId);
    AnalyticsService.trackEvent(EVENT_NAME.COMMON_PRODUCT_MERCHANT_CHANGE, {
      oldProductId: commonProduct.selectedProductId,
      newProductId: productId,
      name: product?.name,
      merchantId: product?.merchantId,
      merchantName: product?.merchant?.displayName,
    });
    setSelectedProductId(productId);
  }


  return (
    <ProductCard
    product={commonProduct.products.find(product => product.id === selectedProductId)}
    commonProductList={commonProduct.products}
    onProductChange={handleProductChange}
    cart={cart}
    clearFromCart={clearFromCart}
    setCart={setCart}
    isRepairPage={isRepairPage}
    />
  );
};

export default CommonProductCard;